import { put, call, takeEvery, all } from 'redux-saga/effects';

import * as actions from '@actions/countries';
import { getCountries } from '@api/countries';
import types from '@constants/action-types';

export const handleGetCountriesRequest = function* ({ payload }) {
  try {
    const response = yield call(getCountries, payload);
    if (response.isAxiosError) return yield put(actions.getCountriesFailure(response.message));
    yield put(actions.getCountriesSuccess(response));
  } catch (e) {
    yield put(actions.getCountriesFailure(e));
  }
};

export default all([takeEvery(types.GET_COUNTRIES_REQUEST, handleGetCountriesRequest)]);
